import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';

export const useBulkMessagingAcls = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getFeatureFlagValue } = useScopedAppFlagStore();

  const hasDomainVerifyAccess = getFeatureFlagValue('domain-verify-settings');

  const hasEmailSettingsAccess = !!selectedLocationIds.find((locationId) =>
    hasSchemaACL(locationId, Permission.EMAIL_SETTINGS_MANAGE)
  );

  const hasBulkMessagingAccess = hasEmailSettingsAccess || hasDomainVerifyAccess;

  return { hasBulkMessagingAccess, hasEmailSettingsAccess, hasDomainVerifyAccess };
};
